import { IdentifierRequestType, IdentifierType } from "../../../types/types";
import { api } from "../api";

/**
 * identifierOnUpdateData - Function that updates on database an existing driver identifier by id 
 * /identifiers/{id}  
 * method PUT  
 * @async-function
 */
const identifierOnUpdateData = async (token: string, model: IdentifierRequestType, id: number) => {
    const response = await api.put(
        `/identifiers/${id}`, {
            ...model
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default identifierOnUpdateData;